import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './api/projects';
import VueGtag from 'vue-gtag';

const app = createApp(App);

app.use(store);
app.use(router);

// Function to check if cookies are accepted
const isCookieAccepted = () => {
  return localStorage.getItem('cookiesAccepted') === 'true';
};

// Function to load Google Analytics if cookies are accepted
const loadGoogleAnalytics = () => {
  if (isCookieAccepted()) {
    app.use(VueGtag, {
      config: {
        id: 'G-JZCJ61Z25D',
        params: {
          anonymize_ip: true,
        },
      },
    });

    // Google Analytics
    router.afterEach((to, from) => {
      if (to === from || !isCookieAccepted()) return;
      const processedTo = to.fullPath.split('?')[0];
      app.config.globalProperties.$gtag.pageview(processedTo);
    });
  }
};

// Initial load of Google Analytics
loadGoogleAnalytics();

app.mount('#app');

// Listen for cookie acceptance event
document.addEventListener('cookieAccepted', () => {
  loadGoogleAnalytics(); // Load Google Analytics script when cookies are accepted
});
